import React from 'react'

export default function DashCardsRow({ children, revelarBarraFiltro }) {
  return (
    <div
      className={
        revelarBarraFiltro === false
          ? 'container-dashboard-fundo'
          : 'container-dashboard-fundo-4'
      }
    >
      {children}
    </div>
  )
}
